import { type TagVariant } from '@loadsmart/miranda-react'

import { formatCurrency } from 'core/utils/currency'

import { type Bid } from '../domain/Bid'

export function getTagVariant(probability?: number): TagVariant {
  if (probability == null) return 'neutral'
  if (probability >= 80) return 'success'
  if (probability >= 40) return 'warning'
  return 'danger'
}

export function getProbabilityPercentageText(probability?: number) {
  return `${probability != null ? Math.round(probability) : '-'}%`
}

export function getProbabilityChartFillVariant(probability?: number) {
  if (probability == null) return '#D9D9D9'
  if (probability >= 80) return '#29D454'
  if (probability >= 40) return '#FFCE4F'
  return '#E80045'
}

export function getBidButtonText(
  displayCountdown: boolean,
  haveActiveBid: boolean,
  isMobile?: boolean,
  countdown?: number,
  price?: number
): string {
  let buttonText = 'BID'

  if (displayCountdown) {
    buttonText += ` again in ${countdown}`
  }

  if (haveActiveBid && isMobile) {
    buttonText += ` ${formatCurrency(price)}`
  }

  return buttonText
}

export function getBidPrice(bid: Bid): string {
  const price = bid.counteredBid?.price ?? bid.price

  return formatCurrency(price)
}

export function getBidCounterPrice(bid: Bid): string | null {
  if (!bid.counteredBid) return null

  return formatCurrency(bid.price)
}
